import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcNight24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m11.808 3.495.404-.827a.5.5 0 0 0 -.51-.715l-.913.11a10.008 10.008 0 0 0 -8.789 9.932c0 5.526 4.48 10.005 10.005 10.005 3.862 0 7.328-2.209 8.994-5.617l.404-.827a.5.5 0 0 0 -.51-.716l-.913.111a8.005 8.005 0 0 1 -8.98-7.946c0-1.234.279-2.426.808-3.51zm-2.477.951-.074.296c-.17.735-.257 1.493-.257 2.263l.004.28c.14 5.117 4.123 9.274 9.167 9.69l.096.007-.135.167a8.005 8.005 0 0 1 -14.132-5.154 8.013 8.013 0 0 1 5.066-7.449z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcNight24;
